import { Routes, Route } from 'react-router-dom';
import { getAppVersion } from './lib/version';
import { InstallBanner } from './components/InstallBanner';

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        <Route path="/" element={<Home />} />
        {/* TODO: Add routes as pages are created */}
      </Routes>
      <InstallBanner />
    </div>
  );
}

function Home() {
  const version = getAppVersion();

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-900">SafetyHub</h1>
        <p className="mt-2 text-base text-gray-600">현장 안전관리 앱</p>
        <p className="mt-4 text-sm text-gray-400">개발 중...</p>
        <p className="mt-8 text-xs text-gray-400">
          v{version.fullVersion} ({version.commitHash})
        </p>
      </div>
    </div>
  );
}

export default App;
